import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { UploadService } from '../../../core/services/upload.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'pp-file-upload',
  templateUrl: 'file-upload.component.html',
})
export class FileUploadComponent {
  @Input() name: string;
  @Input() url: string;
  @Output() onFileSelect = new EventEmitter<any>();

  formatsAllowed = '.jpg, .png, .pdf, .jpeg, .hiec';
  maxSize: number = 10000000;
  acceptOptions = {
    'application/x-extension-jpg': ['.jpg'],
    'application/x-extension-jpeg': ['.jpeg'],
    'application/x-extension-png': ['.png'],
    'application/x-extension-heic': ['.heic'],
    'application/pdf': ['.pdf'],
  };

  @ViewChild('fileInput', { static: true }) fileInput;
  public file: File;

  localPath: any;

  constructor(public uploadService: UploadService, private toastr: ToastrService) {}

  async addFiles() {
    if ((window as any).showOpenFilePicker) {
      try {
        const [fileHandle] = await (window as any).showOpenFilePicker({
          multiple: false,
          excludeAcceptAllOption: true,
          types: [
            {
              description: 'Files',
              accept: this.acceptOptions,
            },
          ],
        });

        const file = await fileHandle.getFile();
        this.readThis(file);
      } catch (err) {
        this.toastr.warning('Error selecting file. Please try again.');
      }
    } else {
      // Fallback for browsers that do not support showOpenFilePicker
      this.fileInput.nativeElement.click();
    }
  }

  onFilesAdded(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.readThis(input.files[0]);
    }
  }

  readThis(inputValue: any): void {
    if (!inputValue) {
      return;
    }

    let fileType = inputValue.name.split('.').pop().toLowerCase();

    // Check if the file type is allowed
    const allowedTypes = Object.values(this.acceptOptions)
      .reduce((acc, val) => acc.concat(val), [])
      .map((ext) => ext.replace('.', '').toLowerCase());
    if (!allowedTypes.includes(fileType)) {
      this.toastr.warning('Invalid file type. Please select a file with JPG or PNG or HEIC or PDF format.');
      return;
    }

    // Check file size is within the limit
    if (this.maxSize && inputValue.size > this.maxSize) {
      this.toastr.warning('File size exceeds the maximum limit of ' + this.maxSize / 1000000 + ' MB.');
      return;
    }

    const reader = new FileReader();
    this.file = inputValue;

    reader.readAsDataURL(inputValue);
    reader.onload = () => {
      this.localPath = reader.result;
      this.onFileSelect.emit({ name: this.name, file: inputValue });
    };
  }

  removeFile(file) {
    // this.files.delete(file);
    this.file = undefined;
    this.fileInput.nativeElement.value = '';
    this.onFileSelect.emit({ name: this.name, file: null });
  }

  isPdf(url) {
    return url.indexOf('.pdf') > -1;
  }
}
